import styled from 'styled-components';

interface BoxWrapperProps {
    maxWidth?: string;
    isTransparent?: boolean;
    isDanger?: boolean;
}

export const ActionBlockWrapper = styled.div<BoxWrapperProps>`
    box-sizing: border-box;
    background-color: ${({ isDanger }) => (isDanger ? '#fff5f5' : '#ffffff')}; 
    width: ${({ maxWidth }) => maxWidth || '100%'};
    margin-bottom: 15px;
    overflow: hidden;
    align-items: center;
    align-self: flex-start;
    border-radius: 12px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
    transition: all 0.3s ease;

    &:hover {
        box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08); 
    }
`;

export const ActionBlockContainer = styled.div`
    padding: 24px 30px;
    width: 100%;

    @media (max-width: 768px) {
        padding: 20px;
    }
`;

export const ActionBlockInfo = styled.div`
    margin-bottom: 20px;
`;

export const ActionBlockTitle = styled.h3`
    font-size: 18px;
    font-weight: 600;
    margin: 0;
    padding: 0;
    max-width: 450px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    color: #1a1a1a;
    line-height: 1.4;
`;

export const ActionBlockDescription = styled.p`
    font-size: 14px;
    margin: 12px 0 0 0;
    padding: 0;
    color: #666666;
    line-height: 1.6;
`;

export const ActionBlockFooter = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 16px 30px;
    background: #f7f7f7;
    border-top: 1px solid #e0e0e0;
    gap: 12px;

    @media (max-width: 768px) {
        padding: 16px 20px;
        flex-wrap: wrap;
    }
`;

export const HeaderWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: flex-start;
    }
`;

export const WarningBlockWrapper = styled.div`
    color: #1a1a1a;
    background: linear-gradient(135deg, #fff3cd 0%, #ffe9a8 100%);
    padding: 14px 16px;
    border-radius: 12px 12px 0 0;
    font-size: 14px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 12px;
    width: 100%;
    position: relative;
    z-index: 2;
    top: 2px;
    line-height: 1.5;

    svg {
        flex-shrink: 0;
        color: #c18344;
    }

    p {
        margin: 0;
    }

    @media (max-width: 768px) {
        padding: 12px 14px;
        font-size: 13px;
    }
`;
